import script from "./DocumentForSigned.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentForSigned.vue?vue&type=script&setup=true&lang=js"

import "./DocumentForSigned.vue?vue&type=style&index=0&id=2dca5957&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dca5957"]])

export default __exports__